import { gql, QueryHookOptions, useQuery } from '@apollo/client'
import { Query, QuerySupplierOpportunitiesArgs } from '../gen/models'

export const SUPPLIER_OPPORTUNITIES_QUERY = gql`
  query supplierOpportunities($input: SupplierOpportunitiesInput!, $pagination: Pagination, $sort: [Sort!]) {
    supplierOpportunities(input: $input, pagination: $pagination, sort: $sort) {
      totalHits
      hits {
        id
        name
        description
        status
        createdAt
        updatedAt
        isArchivedOpportunity
        numberSKU
        dueDate
        supplierStatus
        isManual
        provider {
          name
          address
          address2
          city
          state
          zipCode
        }
        keyContact {
          firstName
          lastName
          email
          phoneNumber
        }
      }
    }
  }
`

export const useSupplierOpportunitiesQuery = (
  baseOptions: QueryHookOptions<Pick<Query, 'supplierOpportunities'>, QuerySupplierOpportunitiesArgs>,
) => useQuery(SUPPLIER_OPPORTUNITIES_QUERY, baseOptions)
